<template>
    <div class="Inspection" v-loading.fullscreen.lock="fullscreenLoading" :style="{ height: Height - 105 + 'px'}">
        <el-container :style="{ height: Height - 105 + 'px'}">
            <el-header height="80px">
                <el-row>
                    <el-col>
                        <h2>日常巡检</h2>
                    </el-col>
                    <el-col :span="12" style="text-align: left; padding-left: 10px;">
                        <el-popover
                            placement="bottom-start"
                            width="400"
                            trigger="manual"
                            v-model="visible">
                            <el-form ref="ruleForms" :model="queryform" label-width="100px">
                                <el-form-item label="巡检类别">
                                    <el-select v-model="queryform.type" placeholder="请选择" clearable>
                                        <el-option v-for="item in TypeList" :key="item.id" :label="item.cName" :value="item.cName">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="开始时间">
                                    <el-date-picker
                                        v-model="queryform.dateS"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        placeholder="选择日期">
                                    </el-date-picker>
                                    <!-- <el-select v-model="queryform.dateS" filterable remote placeholder="请选择" :remote-method="remoteMethod" :loading="loading" @change="changecompany">
                                        <el-option v-for="item in InspectionSetData" :key="item.id" :label="item.title" :value="item.id">
                                        </el-option>
                                    </el-select> -->
                                </el-form-item>
                                <el-form-item label="结束时间">
                                    <el-date-picker
                                        v-model="queryform.dateE"
                                        type="date"
                                        value-format="yyyy-MM-dd"
                                        placeholder="选择日期">
                                    </el-date-picker>
                                    <!-- <el-select v-model="queryform.dateE" filterable remote placeholder="请选择" :remote-method="remoteMethod" :loading="loading" @change="changecompany">
                                        <el-option v-for="item in InspectionSetData" :key="item.id" :label="item.title" :value="item.id">
                                        </el-option>
                                    </el-select> -->
                                </el-form-item>
                            </el-form>
                            <el-row>
                                <el-col style="text-align: right;">
                                    <el-button type="primary" @click="Reset">重置</el-button>
                                    <el-button type="primary" @click="ConfirmQuery">确认</el-button>
                                </el-col>
                            </el-row>
                            <el-button type="primary" slot="reference" @click="visible = !visible">查询</el-button>
                        </el-popover>
                    </el-col>
                    <el-col :span="12">
                        <!-- <el-button type="primary" @click="AddInspection">新增</el-button> -->
                    </el-col>
                </el-row>
            </el-header>
            <el-main>
                <el-table :height="Height - 266" :data="tableData" border style="width: 100%">
                    <el-table-column prop="title" label="巡检标题">
                    </el-table-column>
                    <el-table-column prop="type" label="巡检类别">
                    </el-table-column>
                    <el-table-column prop="date" label="巡检日期">
                    </el-table-column>
                    <el-table-column prop="timeS" label="巡检开始时间">
                    </el-table-column>
                    <el-table-column prop="timeE" label="巡检结束时间">
                    </el-table-column>
                    <el-table-column prop="users" label="巡检人员">
                    </el-table-column>
                    <el-table-column prop="createtime" label="日期">
                    </el-table-column>
                    <el-table-column prop="address" label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="Show(scope.row)">查看</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- <el-dialog :title="title" :visible.sync="Inspection" top="7vh" width="700px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" custom-class="Inspection">
                    <el-form :model="form" :rules="rules" ref="ruleForm" label-width="120px">
                        <el-form-item label="名称" prop="title">
                            <el-input v-model="form.title"></el-input>
                        </el-form-item>
                        <el-form-item label="满意度调研状态">
                            <el-select v-model="form.status" placeholder="请选择">
                                <el-option label="未发布" :value="0">
                                </el-option>
                                <el-option label="已发布" :value="1">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="调研发布时间" v-if="form.status === 1">
                            <el-date-picker
                                v-model="form.timeSlot"
                                type="datetimerange"
                                :picker-options="pickerOptions"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期" align="right">
                            </el-date-picker>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="Inspection = false">取 消</el-button>
                        <el-button type="primary" @click="SaveInspection" :loading="confirmloding">确 定</el-button>
                    </div>
                </el-dialog> -->
                <el-dialog :title="title" :visible.sync="drawer" top="7vh" width="800px" :close-on-click-modal="false" :close-on-press-escape="false" custom-class="InspectionDetail">
                    <!-- <span>我来啦!</span> -->
                    <el-table :height="Height - 350" :data="InspectionDetail" border style="width: 100%">
                        <el-table-column prop="area" width="100" show-overflow-tooltip label="楼层">
                        </el-table-column>
                        <el-table-column prop="floor" width="100" show-overflow-tooltip label="区域">
                        </el-table-column>
                        <el-table-column prop="intro" width="200" show-overflow-tooltip label="问题">
                        </el-table-column>
                        <el-table-column prop="solve" width="200" show-overflow-tooltip label="跟进措施">
                        </el-table-column>
                        <el-table-column prop="status" width="200" show-overflow-tooltip label="整改完成情况">
                        </el-table-column>
                        <el-table-column prop="imgs" width="300" label="巡检图片">
                            <template slot-scope="scope">
                                <!-- {{scope.$index}} -->
                                <div class="li" v-for="item in scope.row.imgs" :key="item.id">
                                    <el-popover
                                        placement="bottom-start"
                                        trigger="hover">
                                        <img :src="url + item.response" height="150px">
                                        <img slot="reference" :src="url + item.response" height="25px">
                                    </el-popover>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="address" fixed="right" label="操作" align="center">
                            <template slot-scope="scope">
                                <el-button type="text" @click="Edit(scope.row)">编辑</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-dialog>
                <el-dialog title="修改整改完成情况" :visible.sync="Rectification" top="7vh" width="600px" :close-on-click-modal="false" :close-on-press-escape="false" custom-class="Rectification">
                    <el-form :model="forms" :rules="rule" ref="rule"  label-width="120px">
                        <el-form-item label="整改完成情况" prop="status">
                            <el-input type="textarea" v-model="forms.status"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="Rectification = false">取 消</el-button>
                        <el-button type="primary" @click="SaveRectification" :loading="confirmloding">确 定</el-button>
                    </div>
                </el-dialog>
            </el-main>
            <el-footer>
                <el-row>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="total"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="12" style="text-align: center;">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="->, sizes"
                            :total="total">
                        </el-pagination>
                    </el-col>
                </el-row>
            </el-footer>
        </el-container>
  </div>
</template>

<script>
/*eslint-disable */
import { getToken, getAdminId } from "../../../utils/auth";
import https from "../../../utils/http";
export default {
    name: "Inspection",
    data () {
        return {
            url: https.http,
            visible: false,
            fullscreenLoading: false,
            tableData: [],
            Inspection: false,
            form: {
                title: '',
                status: 1,
                timeSlot: []
            },
            title: '',
            currentPage: 1,
            Size: 20,
            total: 1,
            visible: false,
            queryform: {
                dateS: '',
                dateE: '',
                type: ''
            },
            Uploaddata: {
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            },
            http: https.https,
            preview: false,
            fileList: [],
            rules: {
                title: [
                    { required: true, message: '请输入公司名称', trigger: 'blur' }
                ]
            },
            confirmloding: false,
            InspectionSetData: [],
            loading: false,
            drawer: false,
            InspectionDetail: [],
            InspectionDetailData: {},
            TemplateTitleData: {},
            Rectification: false,
            forms: {
                status: ''
            },
            rule: {
                status: [
                    { required: true, message: '请输入整改完成情况', trigger: 'blur' }
                ]
            },
            Titlerow: {},
            TypeList: []
        }
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        AddInspection () {
            this.Inspection = true
            this.title = '新增公司'
            this.form = {
                title: '',
                status: 1,
                timeSlot: []
            }
            this.fileList = []
        },
        handleSizeChange(size) {
            this.Size = size
            this.fullscreenLoading = true
            this.GetInspectionList()
        },
        handleCurrentChange(page) {
            this.currentPage = page
            this.fullscreenLoading = true
            this.GetInspectionList()
        },
        GetInspectionList (keyword, room) {
            let data = {
                dateS: this.queryform.dateS,
                dateE: this.queryform.dateE,
                type: this.queryform.type,
                limit: this.Size,
                page: this.currentPage,
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            }
            this.$store.dispatch('InspectionListShow', data).then(res => {
                this.fullscreenLoading = false
                this.total = res.something
                this.tableData = res.data
                this.form = {
                    title: '',
                    status: 1,
                    timeSlot: []
                }
                this.visible = false
            })
        },
        Reset () {
           this.$refs['ruleForms'].resetFields();
           this.queryform = {
                dateS: '',
                dateE: '',
                type: ''
            }
        },
        ConfirmQuery() {
            this.fullscreenLoading = true
            this.currentPage = 1
            this.GetInspectionList()
            // for (let item in this.InspectionSetData) {
            //     if (this.InspectionSetData[item].id === this.queryform.report_id) {
            //         this.title = this.InspectionSetData[item].title
            //     }
            // }
        },
        SaveInspection() {
            let that = this
            let data = JSON.parse(JSON.stringify(this.form))
            data.ADMIN_ID = getAdminId();
            data.ADMIN_TOKEN = getToken();
            data.img = JSON.stringify(this.form.img)
            // this.$refs['ruleForm'].validate((valid) => {
            //     if (valid) {
            //         this.confirmloding = true
            //         that.$store.dispatch('SaveInspection', data).then(res => {
            //             if (res.flag) {
            //                 that.$message({
            //                     message: res.message,
            //                     type: 'success'
            //                 })
            //                 that.confirmloding = false
            //                 that.Inspection = false
            //                 that.fullscreenLoading = true
            //                 that.GetInspectionList(that.queryform.keyword, that.queryform.room)
            //             } else {
            //                 that.$message({
            //                     message: res.message,
            //                     type: 'warning'
            //                 })
            //             }
            //         })
            //     } else {
            //         return false;
            //     }
            // });
            
        },
        EditInspection(row) {
            this.Inspection = true
            this.title = '编辑公司'
            this.form = JSON.parse(JSON.stringify(row))
            this.fileList = JSON.parse(this.form.img)
            this.form.img = JSON.parse(this.form.img)
        },
        DelInspection(row) {
            this.$confirm('是否删除该公司？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                row.ADMIN_ID = getAdminId();
                row.ADMIN_TOKEN = getToken();
                this.$store.dispatch('DelInspection', row).then(res => {
                     if (res.flag) {
                        this.$message({
                            message: res.message,
                            type: 'success'
                        })
                        this.fullscreenLoading = true
                        this.GetInspectionList()
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'warning'
                        })
                    }
                })
            }).catch(() => {
            })
        },
        remoteMethod (query) {
            if (query !== '') {
                this.loading = true
                let data = {
                    limit: 100,
                    page: 1,
                    ADMIN_ID: getAdminId(),
                    ADMIN_TOKEN: getToken(),
                }
                data.keyword = query
                this.$store.dispatch('InspectionSetListShow', data).then(res => {
                    this.InspectionSetData = res.data
                    this.loading = false
                })
            } else {
                this.loading = true
                let data = {
                    limit: 100,
                    page: 1,
                    ADMIN_ID: getAdminId(),
                    ADMIN_TOKEN: getToken(),
                }
                this.$store.dispatch('InspectionSetListShow', data).then(res => {
                    this.InspectionSetData = res.data
                    this.loading = false
                })
            }
        },
        changecompany (e) {
        },
        GetInspectionSetList (keyword, room) {
            let data = {
                limit: 100,
                page: 1,
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken(),
            }
            this.$store.dispatch('InspectionSetListShow', data).then(res => {
                this.InspectionSetData = res.data
            })
        },
        Show (row) {
            let data = {
                id: row.id,
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken(),
            }
            this.Titlerow = JSON.parse(JSON.stringify(row))
            this.title = row.title
            this.$store.dispatch('InspectionDetailShow', data).then(res => {
                for (let item in res.something) {
                    res.something[item].imgs = JSON.parse(res.something[item].imgs)
                }
                this.fullscreenLoading = false
                this.InspectionDetail = res.something
                this.drawer = true
            })
        },
        InspectionTemplate(row) {
            
        },
        Edit (row) {
            this.Rectification = true
            console.log(row)
            this.forms.status = JSON.parse(JSON.stringify(row.status))
            this.forms.id = JSON.parse(JSON.stringify(row.id))
        },
        SaveRectification () {
            let that = this
            this.$refs['rule'].validate((valid) => {
                if (valid) {
                    that.confirmloding = true
                    let data = JSON.parse(JSON.stringify(that.forms));
                    data.ADMIN_ID = getAdminId();
                    data.ADMIN_TOKEN = getToken();
                    that.$store.dispatch('InspectionDetailSave', data).then(res => {
                        that.fullscreenLoading = true
                        that.Rectification = false
                        that.confirmloding = false
                        that.Show(this.Titlerow)
                    })
                } else {
                    return false
                }
            });
        },
        GetTypeList() {
            let data = {
                PK_EY_Enum: "02e9cc26f999da546ea32eb12ffbfd3c"
            }
            this.$store.dispatch('GetTreeDataItem', data).then((res) => {
                this.TypeList = res.data
            })
        }
    },
    created() {
        this.fullscreenLoading = true
        this.GetInspectionList()
        this.GetTypeList()
        // this.GetInspectionSetList()
    },
    computed: {
        Height() {
            return this.$store.state.loginModule.Height;
        }
    }
}
</script>

<style>
.Inspection {
    width: 100%;
}
.Inspection .el-header .el-row .el-col {
    height: 40px;
    line-height: 40px;
}
.Inspection .el-header .el-row .el-col h2 {
    text-align: center;
}
.Inspection .el-header .el-row .el-col {
    text-align: center;
}
.Inspection .el-header .el-row .el-col:last-child {
    text-align: right;
}
.Inspection .el-main {
    padding-top: 0px;
    padding-bottom: 0px;
}
.Inspection .el-main .el-table td {
    height: 40px;
}
.Inspection .el-main .Inspection .el-dialog__body {
    padding-top: 0px;
    padding-bottom: 0px;
}
.Inspection .el-main .Inspection .el-dialog__body .el-form-item {
    display: inline-block;
    width: 50%;
}
/* .Inspection .el-main .InspectionDetail .el-drawer__body {
    color: #000;
    padding: 0px 20px;
}
.Inspection .el-main .InspectionDetail .el-drawer__body .title {
    text-align: center;
    font-size: 18px;
    font-weight: 700;
}
.Inspection .el-main .InspectionDetail .el-drawer__header {
    margin: 0px;
    font-size: 18px;
    font-weight: 600;
}
.Inspection .el-main .InspectionDetail .el-drawer__body ul li {
    margin-top: 10px;
}
.Inspection .el-main .InspectionDetail .el-drawer__body ul li .body {
    padding-left: 20px;
    margin-top: 5px;
    color: #999;
}
.Inspection .el-main .InspectionDetail .el-drawer__body ul li .body .el-checkbox {
    display: block;
    height: 30px;
    line-height: 30px;
}
.Inspection .el-main .InspectionDetail .el-drawer__body ul li .body .el-radio {
    display: block;
    height: 30px;
    line-height: 30px;
} */
.Inspection .el-main .InspectionDetail td {
    height: 45px !important;
}
.Inspection .el-main .InspectionDetail .cell .li {
    line-height: 30px;
    height: 30px;
    display: inline-block;
    vertical-align: top;
}
.Inspection .el-main .InspectionDetail .cell .li>span{
    height: 100%;
}
.Inspection .el-main .InspectionDetail .cell .li .el-popover__reference-wrapper {
    height: 100%;
}
</style>
